export default __webpack_public_path__ + "static/6-b0b184e0ed6f07c9368117929455e5dc.jpg";